var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFilters = function SvgCloseFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.899 7.051a1 1 0 0 0-1.414 0l-3.536 3.535-3.535-3.535A1 1 0 0 0 7 8.465L10.535 12 7 15.535a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 0 0 1.414-1.414L13.364 12l3.535-3.535a1 1 0 0 0 0-1.414"
  })));
};
export { SvgCloseFilters as ReactComponent };